export const environment = {
	staging: true,
	production: false,
	baseUrl: 'https://mhealth-v2-staging.kooli.io',
	ApiBaseURL: 'https://api-mhealth-v2-staging.kooli.io',
	MapsJavascriptApi: 'AIzaSyDDSh0QQx95LC8DzrPV7l2tLicR1I7RhpU',
};
